
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sets",
      function () {
        return require("private-next-pages/sets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sets"])
      });
    }
  